module.exports = __webpack_public_path__ + "img/1.ba5eec38.svg";